import InnerComponent from '@Components/Purchase/Rfq/RfqForm';
import orgContainer from '@Components/AppContainer';

const RfqForm = () => ((orgContainer(InnerComponent)));
export default RfqForm;